module.exports = __webpack_public_path__ + "static/img/img(49).a809a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(49).png
// module id = Imx5
// module chunks = 1